import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type DirectoryTitle from '../components/directory-title.vue'

export const treeSelectDirectoryTitleProps = buildProps({
  /**
   * @description 是否收起
   */
  isCollapseMenu: {
    type: Boolean
  }
} as const)

export const treeSelectDirectoryTitleEmits = {
  collapseMenu: () => true // 菜单展开/收起
}

// props
export type TreeSelectDirectoryTitleProps = ExtractPropTypes<
  typeof treeSelectDirectoryTitleProps
>

// emits
export type TreeSelectDirectoryTitleEmits = typeof treeSelectDirectoryTitleEmits

// instance
export type TreeSelectDirectoryTitleInstance = InstanceType<
  typeof DirectoryTitle
>
